module.exports = "/_next/static/images/OrchestrateJourneys@2x-a91501c2db15f398cceb6cfc17798b97.png";